import { Liquid } from 'liquidjs';
import * as comUtils from "common/utils";
export * from "common/cart-utils";
export * from "common/utils";

export function liquidRender(template, params) {
  const engine = new Liquid();
  return engine.parseAndRenderSync(template, params);
}

export function jQueryExists() {
  return typeof jQuery !== 'undefined';
}

export function convertShopifyCentsToAmount(cents) {
  if (!cents) return 0;
  return (cents / 100.0).toFixed(2);
}

export function formatCartAmountForShopify(cartAmount) {
  cartAmount = comUtils.formatAmount(cartAmount);
  cartAmount = convertShopifyCentsToAmount(cartAmount);
  return cartAmount;
}

export function formatCartAmountForEasyStore(cartAmount) {
  cartAmount = comUtils.formatAmount(cartAmount);
  return cartAmount;
}

export function formatAmountDisplay(amount) {
  if (!parseFloat(amount) && parseFloat(amount) !== 0) amount = 0;
  let newAmount = parseFloat(amount).toFixed(2);
  newAmount = newAmount.replace(".00", "");
  newAmount = newAmount.toLocaleString();
  return newAmount;
}

export function extractEasyStoreCartAmount(response) {
  if (!response.hasOwnProperty('total_price')) return;
  let cartAmount = formatCartAmountForEasyStore(response.total_price);
  if (!comUtils.isNumeric(cartAmount)) return;
  return cartAmount;
}
